var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6797 2.079H15.2125V1.38525C15.2125 0.991777 14.8935 0.672754 14.5 0.672754C14.1065 0.672754 13.7875 0.991777 13.7875 1.38525V2.079H6.2125V1.38525C6.2125 0.991777 5.89352 0.672754 5.5 0.672754C5.10648 0.672754 4.7875 0.991777 4.7875 1.38525V2.079H3.32031C1.95803 2.079 0.85 3.18703 0.85 4.54932V16.5024C0.85 17.8647 1.95803 18.9728 3.32031 18.9728H16.6797C18.042 18.9728 19.15 17.8647 19.15 16.5024V4.54932C19.15 3.18703 18.042 2.079 16.6797 2.079ZM3.32031 3.504H4.7875V3.9165C4.7875 4.30998 5.10648 4.629 5.5 4.629C5.89352 4.629 6.2125 4.30998 6.2125 3.9165V3.504H13.7875V3.9165C13.7875 4.30998 14.1065 4.629 14.5 4.629C14.8935 4.629 15.2125 4.30998 15.2125 3.9165V3.504H16.6797C17.256 3.504 17.725 3.97305 17.725 4.54932V5.73525H2.275V4.54932C2.275 3.97305 2.74405 3.504 3.32031 3.504ZM16.6797 17.5478H3.32031C2.74405 17.5478 2.275 17.0787 2.275 16.5024V7.16025H17.725V16.5024C17.725 17.0787 17.256 17.5478 16.6797 17.5478Z",
    fill: "#F99B9B",
    stroke: "#F99B9B",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.926a7cb919f98e69224a13d6c198d03f.svg";
export { ForwardRef as ReactComponent };